import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { useMemo } from 'react'

import {
  Cid10NotificacaoAgravoModel,
  IdNomeNotificacaoModel,
  NotificacaoAgravoFormModel,
} from './model-notificacaoAgravo'
import { NotificacaoAgravoModal } from './NotificacaoAgravoModal'

interface NotificacaoAgravoModalContainerProps {
  cid10s: ReadonlyArray<Cid10NotificacaoAgravoModel>
  onClose(): void
}

export function NotificacaoAgravoModalContainer(props: Readonly<NotificacaoAgravoModalContainerProps>) {
  const { cid10s, onClose } = props

  const acessoLotacaoOrEstagio = useAcessoLotacaoOrEstagio()
  const acesso = acessoLotacaoOrEstagio?.acesso

  const initialValues = useMemo<NotificacaoAgravoFormModel>(
    () => ({
      notificacao: {
        unidadeSaude: toIdNome(acesso?.unidadeSaude),
        municipio: toIdNome(acesso?.municipio),
        uf: toIdNome(acesso?.municipio?.uf),
      },
    }),
    [acesso]
  )

  const handleSubmit = (_values: NotificacaoAgravoFormModel) => {
    // TODO: enviar a notificação de agravo para o SINAN (#35068).
    onClose()
  }

  return (
    <NotificacaoAgravoModal cid10s={cid10s} initialValues={initialValues} onClose={onClose} onSubmit={handleSubmit} />
  )
}

const toIdNome = (item?: { id: ID; nome?: string | null }): IdNomeNotificacaoModel | undefined =>
  item?.nome ? { id: item.id, nome: item.nome } : undefined
